module.exports = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\"><polyline fill=\"none\" stroke=\"currentColor\" stroke-width=\"2\" points=\"3 9 7 12 13 4 \"></polyline></svg>"


//////////////////
// WEBPACK FOOTER
// ../src/client/assets/svg/check.svg
// module id = 1512
// module chunks = 0